export const CHECKOUT_MAX_LINE_ITEMS = 30
export const CHECKOUT_MAX_COMPLIMENTARY_LINE_ITEMS = 5
export const CHECKOUT_MAX_QUANTITY = 20

const sameId = (left, right) => String(left) === String(right)

export const getReservedVariantQuantity = (cart, productId, variantId) =>
	cart.reduce((total, item) => {
		if (
			(item.product_type === 'product' || item.product_type === 'freeProduct') &&
			sameId(item.product_strapi_id, productId) &&
			sameId(item.product_variant_strapi_id, variantId)
		) {
			return total + item.product_count
		}
		if (item.product_type !== 'bundle') return total

		let bundleQuantity = 0
		if (
			sameId(item.product_one_strapi_id, productId) &&
			sameId(item.product_variant_one_strapi_id, variantId)
		) {
			bundleQuantity += item.product_one_anzahl * item.product_count
		}
		if (
			sameId(item.product_two_strapi_id, productId) &&
			sameId(item.product_variant_two_strapi_id, variantId)
		) {
			bundleQuantity += item.product_two_anzahl * item.product_count
		}
		return total + bundleQuantity
	}, 0)

export const canAddLine = (cart, existingLine) =>
	Boolean(existingLine) ||
	cart.filter((item) => item.product_type !== 'freeProduct').length <
		CHECKOUT_MAX_LINE_ITEMS

export const canAddComplimentaryLine = (cart, existingLine) =>
	Boolean(existingLine) ||
	cart.filter((item) => item.product_type === 'freeProduct').length <
		CHECKOUT_MAX_COMPLIMENTARY_LINE_ITEMS
